import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/fonts/PlusJakartaSans-Bold/PlusJakartaSans-Bold.ttf";
import "./assets/fonts/PlusJakartaSans-Regular/PlusJakartaSans-Regular.ttf";

import "./assets/fonts/PlusJakartaSans-Medium/PlusJakartaSans-Medium.ttf";
import "./assets/fonts/PlusJakartaSans-SemiBold/PlusJakartaSans-SemiBold.ttf";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
